import { render, staticRenderFns } from "./DeleteAutoActivityForm.vue?vue&type=template&id=6f667ddc&scoped=true&lang=pug&"
import script from "./DeleteAutoActivityForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./DeleteAutoActivityForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DeleteAutoActivityForm.vue?vue&type=style&index=0&id=6f667ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f667ddc",
  null
  
)

export default component.exports